import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Role } from "../../models/RoleModel";

// src/features/auth/authSlice.ts

interface AdministrationState {
  roles: Role[];
}

const initialState: AdministrationState = {
  roles: [],
};

export const administrationSlice = createSlice({
  name: "administration",
  initialState,
  reducers: {
    setRoles(state, action: PayloadAction<{ roles: Role[] }>) {
      state.roles = action.payload.roles;
    },
  },
});

export const { setRoles } = administrationSlice.actions;
export default administrationSlice.reducer;
